module.exports = __webpack_public_path__ + "img/calendario_outline.018ec39c.svg";